export const timeZones = [
  { Id: "-12:00", Timezone: "(GMT -12:00), Eniwetok, Kwajalein" },
  { Id: "-11:00", Timezone: "(GMT -11:00) Midway Island, Samoa" },
  { Id: "-10:00", Timezone: "(GMT -10:00) Hawaii" },
  { Id: "-09:00", Timezone: "(GMT -09:00) Alaska" },
  { Id: "-08:00", Timezone: "(GMT -08:00) Pacific Time (US &amp; Canada)" },
  { Id: "-07:00", Timezone: "(GMT -07:00) Mountain Time (US &amp; Canada)" },
  {
    Id: "-06:00",
    Timezone: "(GMT -06:00) Central Time (US &amp; Canada), Mexico City",
  },
  {
    Id: "-05:00",
    Timezone: "(GMT -05:00) Eastern Time (US &amp; Canada), Bogota, Lima",
  },
  {
    Id: "-04:00",
    Timezone: "(GMT -04:00) Atlantic Time (Canada), Caracas, La Paz",
  },
  { Id: "-03:50", Timezone: "(GMT -03:30) Newfoundland" },
  { Id: "-03:00", Timezone: "(GMT -03:00) Brazil, Buenos Aires, Georgetown" },
  { Id: "-02:00", Timezone: "(GMT -02:00) Mid-Atlantic" },
  { Id: "-01:00", Timezone: "(GMT -01:00 hour) Azores, Cape Verde Islands" },
  {
    Id: "+00:00",
    Timezone: "(GMT) Western Europe Time, London, Lisbon, Casablanca",
  },
  {
    Id: "+01:00",
    Timezone: "(GMT +01:00 hour) Brussels, Copenhagen, Madrid, Paris",
  },
  { Id: "+02:00", Timezone: "(GMT +02:00) Kaliningrad, South Africa" },
  {
    Id: "+03:00",
    Timezone: "(GMT +03:00) Baghdad, Riyadh, Moscow, St. Petersburg",
  },
  { Id: "+03:30", Timezone: "(GMT +03:30) Tehran" },
  { Id: "+04:00", Timezone: "(GMT +04:00) Abu Dhabi, Muscat, Baku, Tbilisi" },
  { Id: "+04:30", Timezone: "(GMT +04:30) Kabul" },
  {
    Id: "+05:00",
    Timezone: "(GMT +05:00) Ekaterinburg, Islamabad, Karachi, Tashkent",
  },
  {
    Id: "+05:30",
    Timezone: "(GMT +05:30) Bombay, Calcutta, Madras, New Delhi",
  },
  { Id: "+05:45", Timezone: "(GMT +05:45) Kathmandu" },
  { Id: "+06:00", Timezone: "(GMT +06:00) Almaty, Dhaka, Colombo" },
  { Id: "+07:00", Timezone: "(GMT +07:00) Bangkok, Hanoi, Jakarta" },
  {
    Id: "+08:00",
    Timezone: "(GMT +08:00) Beijing, Perth, Singapore, Hong Kong",
  },
  {
    Id: "+09:00",
    Timezone: "(GMT +09:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
  },
  { Id: "+09:30", Timezone: "(GMT +09:30) Adelaide, Darwin" },
  {
    Id: "+10:00",
    Timezone: "(GMT +10:00) Eastern Australia, Guam, Vladivostok",
  },
  {
    Id: "+11:00",
    Timezone: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia",
  },
  {
    Id: "+12:00",
    Timezone: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka",
  },
];
